export const VIEWS = {
  CHART: 'Chart',
  TABLE: 'Table',
} as const;

export const DISPLAY_TYPE = {
  EQUITY: 'equity',
  FIXED_INCOME: 'fixed-income',
  ALL: 'all',
  NO_DATA: 'no-data',
} as const;

export const INVESTMENT_TYPE = {
  US_EQUITY: 'U.S. Equity',
  INTERNATIONAL_EQUITY: 'International Equity',
  FIXED_INCOME: 'Fixed Income',
  MULTI_ASSET: 'Multi-Asset',
} as const;

export const Constants = {
  TAG_NAME: 'pop-sector-diversification-component',
  COMPONENT_TITLE: 'Sector diversification',
  EQUITY_TITLE: 'Equity',
  FIXED_INCOME_TITLE: 'Fixed income',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'data-as-of-select',
  VIEW_DROPDOWN_LABEL: 'View',
  VIEW_DROPDOWN_ID: 'view-select',
  VIEWS: [VIEWS.CHART, VIEWS.TABLE],
  DEFAULT_VIEW: VIEWS.CHART,
  BENCHMARK_PREFIX: 'Benchmark:',
  NO_DATA_AVAILABLE: 'Sector diversification unavailable',
  NO_TABLE_DATA_AVAILABLE: 'Sector diversification table unavailable',
  NO_CHART_DATA_AVAILABLE: 'Sector diversification chart unavailable',
  DEFAULT_TAB: DISPLAY_TYPE.EQUITY,
} as const;
